import { render, staticRenderFns } from "./MyIp.vue?vue&type=template&id=42bd26b1&"
import script from "./MyIp.vue?vue&type=script&lang=js&"
export * from "./MyIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports